import React from 'react';
import {Carousel, Col, Container, Image, ListGroup, Nav, Navbar, NavDropdown, Row} from "react-bootstrap";
import logo from './images/logo.png'
import {CameraVideo, EyeFill, Globe, MusicNoteBeamed, Power, Save,Question} from 'react-bootstrap-icons';
import {HomePageResponseJson, MediaItemJson} from "../interfaces";
import {MessageListItem} from "./MessageListItem";
import {ImageListItem} from './ImageListItem';
import {MediaListItem} from "./MediaListItem";
import {TFunction} from "i18next";
import {AlertItem} from "../../components/alert_item/AlertItem";


interface HomePageProps {
    homePageData: HomePageResponseJson,

    onClickDownloadMedia(mediaItemJson: MediaItemJson),

    onClickLogout(),

    onClickLanguage(language: string),

    onClickRefresh(),

    alertVisible: boolean,
    onClickClose(),

    t: TFunction
}

export const HomePage = ({homePageData, alertVisible, onClickClose, onClickDownloadMedia, onClickLanguage, onClickRefresh, onClickLogout, t}: HomePageProps) =>
    <Container>
        <AlertItem alertHeader={t('alert.header')}
                   alertText={t('alert.defaultError')}
                   isVisible={alertVisible} onClickClose={onClickClose}/>
        <Row>
            <Image style={{width: '100%', padding: 0}} src={logo}/>
        </Row>
        <Row>
            <Navbar bg={'light'} expand={'lg'}>
                <Container>
                    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link style={{paddingRight: '15px'}} onClick={onClickRefresh}>
                                <span style={{paddingRight: '10px'}}><EyeFill/></span>{t('menu.refresh')}
                            </Nav.Link>


                            <NavDropdown title={<React.Fragment><span
                                style={{paddingRight: '10px'}}><Globe/></span>{t('menu.languages')}</React.Fragment>}
                                         id="collasible-nav-dropdown"
                                         style={{paddingRight: '15px'}}>

                                <NavDropdown.Item
                                    onClick={() => onClickLanguage('pl')}>{t('menu.polish')}</NavDropdown.Item>
                                <NavDropdown.Item
                                    onClick={() => onClickLanguage('en')}>{t('menu.english')}</NavDropdown.Item>
                            </NavDropdown>

                            <Nav.Link style={{paddingRight: '15px'}} onClick={onClickLogout}>
                                <span style={{paddingRight: '10px'}}><Power/></span>{t('menu.logout')}
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </Row>

        <Row style={{marginTop: '15px'}}>
            <Col>
                <ListGroup style={{fontSize: '13px'}}>
                    <MessageListItem name={t('mms.date')} value={homePageData.date}/>
                    <MessageListItem name={t('mms.size')} value={homePageData.size}/>
                    <MessageListItem name={t('mms.from')} value={homePageData.from}/>
                    <MessageListItem name={t('mms.to')} value={homePageData.to}/>
                    <MessageListItem name={t('mms.subject')} value={homePageData.subject}/>
                    <MessageListItem name={t('mms.attachments')} value={''}/>
                    {homePageData.images.map(item => <ImageListItem mediaItemJson={item}
                                                                    onClickDownload={onClickDownloadMedia}/>)}
                    {homePageData.videos.map(item => <MediaListItem mediaItemJson={item} MediaIcon={MusicNoteBeamed}
                                                                    onClickDownload={onClickDownloadMedia}/>)}
                    {homePageData.audios.map(item => <MediaListItem mediaItemJson={item} MediaIcon={CameraVideo}
                                                                    onClickDownload={onClickDownloadMedia}/>)}
                    {homePageData.unrecognized.map(item => <MediaListItem mediaItemJson={item} MediaIcon={Question}
                                                                    onClickDownload={onClickDownloadMedia}/>)}



                </ListGroup>
            </Col>
            <Col xs={12} lg={8} style={{marginTop: '20px'}}>
                <Carousel variant={'dark'} interval={20000}>

                    {homePageData.messages.map((item: string) =>
                        <Carousel.Item style={{height: '500px'}}>
                            <p style={{width: '70%', marginLeft: '15%'}}>{item}</p>
                        </Carousel.Item>
                    )}


                    {homePageData.images.map((item: MediaItemJson) =>
                        <Carousel.Item style={{textAlign: 'center'}}>
                            <img style={{width: '70%', textAlign: 'center'}}
                                 src={`data:image/png;base64,${item.data}`}/>
                        </Carousel.Item>
                    )}

                    {homePageData.videos.map((item: MediaItemJson) =>
                        <Carousel.Item style={{textAlign: 'center'}}>
                            <video controls style={{width: '70%', textAlign: 'center'}}
                                   src={`data:video/mp4;base64,${item.data}`}/>
                        </Carousel.Item>
                    )}

                    {homePageData.audios.map((item: MediaItemJson) =>
                        <Carousel.Item style={{textAlign: 'center', height: '500px',}}>
                            <audio controls style={{textAlign: 'center', width: '70%', marginTop: '200px'}}
                                   src={`data:audio/amr;base64,${item.data}`}/>
                        </Carousel.Item>
                    )}

                </Carousel>
            </Col>

        </Row>

    </Container>
;